import Axios from "axios";

const baseURLs: Record<string, string> = {
  local: "http://localhost:8080/api/",  // Temporarily use absolute URL until proxy is fixed
  production: "https://app.kairosiq.ai/api/",
};

const env = process.env.REACT_APP_ENV as keyof typeof baseURLs;

const axiosInstance = Axios.create({
  baseURL:
    env === "production"
      ? "https://app.kairosiq.ai/api/"
      : "http://localhost:8080/api/",  // Temporarily use absolute URL until proxy is fixed
    withCredentials: true,
})
// TEMPORARY: Using absolute URLs to bypass proxy issue
// TODO: Fix setupProxy.js and revert to relative URLs (/api/) for proper proxy usage
// React dev server proxy (setupProxy.js) should forward /api requests to http://localhost:8080
// Node.js server handles dashboard data, while Flask API handles AI/ML inference

// Add request interceptor for debugging and authentication
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('🌐 [API] Making request to:', config.url);
    
    // Add JWT token to Authorization header if available
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔐 [API] Added Bearer token to request');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('✅ [API] Response received:', response.status, response.config?.url);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn('❌ [API] Authentication failed - user might need to log in');
    } else if (error.response?.status === 404) {
      console.warn('❌ [API] Endpoint not found:', error.config?.url);
    } else {
      console.error('❌ [API] Request failed:', error.response?.status, error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
